import { StaticImageData } from 'next/image';

export type Event = {
  title: string;
  startDate: string;
  endDate: string;
  location: string;
  cover: string | StaticImageData;
  link: string;
  type: string;
  ctaLabel: string;
  gridCover?: string | StaticImageData;
};

export type BuilderEvent = { value?: { data?: Event }; id: string };

export type ImageProps = {
  src: string;
  alt: string;
};

export function getEventDays(start: string, end: string) {
  const startFrmtd = new Date(start);
  const endFrmtd = new Date(end);
  if (startFrmtd.toDateString() === endFrmtd.toDateString())
    return `${endFrmtd.toLocaleDateString('en-US', {
      day: 'numeric',
      timeZone: 'UTC'
    })} ${startFrmtd.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    })}`;

  return `${startFrmtd.toLocaleDateString('en-US', {
    day: 'numeric',
    timeZone: 'UTC'
  })}-${endFrmtd.toLocaleDateString('en-US', {
    day: 'numeric',
    timeZone: 'UTC'
  })} ${startFrmtd.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    timeZone: 'UTC'
  })}`;
}
